import { useTranslation } from "react-i18next";
import PrimaryBtn from "../button/PrimaryBtn";
import SecondaryBtn from "../button/SecondaryBtn";

interface ConfirmPlayAgainModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const ConfirmPlayAgainModal = ({ isOpen, onClose, onConfirm }: ConfirmPlayAgainModalProps) => {
  const { t } = useTranslation();
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/80 flex items-center justify-center lg:p-[1%] p-4 z-50">
      <div className="modal bg-white-500 2xl:rounded-[2.083vw] lg:rounded-[40px] md:rounded-4xl rounded-3xl 2xl:p-[2vw] lg:p-10 md:p-7 p-4 2xl:max-w-[26.04vw] max-w-[500px] w-full relative animate-[slideUp_0.3s_ease-out] lg:border-[0.2vw] border-3 border-primary auth-page overflow-auto lg:max-h-[calc(100dvh-11%)] max-h-[calc(100dvh-40px)] hide-scroll">
        <div className="text-center">
          <h4 className="2xl:text-[1.5625vw]/[1.7vw] xl:text-3xl/6 text-2xl/6 font-bold text-primary-orange 2xl:mb-[0.42vw] md:mb-2 mb-1 landscape:max-lg:mb-1">
            {t("gameResult.playAgainTitle", { defaultValue: "Play again" })}
          </h4>
          <p className="2xl:text-[1.041vw]/[1.15vw] md:text-xl/tight text-base/tight landscape:max-lg:text-base/tight text-black-800 text-center font-bold 2xl:mb-[1.67vw] md:mb-[30px] mb-3 landscape:max-lg:mb-3">
            {t("gameResult.playAgainDescription", {
              defaultValue: "Start a new game using the same teams, participants, and lifelines.",
            })}
          </p>

          <div className="flex flex-row 2xl:gap-[1vw] gap-2 justify-center w-full 2xl:mt-[1.67vw] xl:mt-8 md:mt-5 mt-4 landscape:max-lg:mt-4">
            <SecondaryBtn onClick={onClose} className="w-1/2 lg:mb-0 md:mb-0 mb-0">
              {t("exitGameModal.cancel", { defaultValue: "Cancel" })}
            </SecondaryBtn>
            <PrimaryBtn onClick={onConfirm} className="w-1/2 lg:mb-0 md:mb-0 mb-0">
              {t("gameResult.confirmPlayAgain", { defaultValue: "Play again" })}
            </PrimaryBtn>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmPlayAgainModal;

